import React from "react";

import { useConfig } from "@/context/ConfigContext";
import ChevronDown from "../icons/ChevronDown";

const SupportDetailCard = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const { config } = useConfig();

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };
  return (
    <div className="p-4 font-openSans">
      <h3>24/7 Customer Support</h3>
      <div className="flex flex-col space-y-4 p-3 mt-4 mb-8 border border-slate-200 shadow-md rounded-md">
        <div className="flex flex-col space-y-1">
          <p className="text-xs font-medium text-slate-500">Phone</p>
          <p className="text-sm text-slate-900">
            {config?.config.support.phone}
          </p>
        </div>
        <hr />
        <div className="flex flex-col space-y-1">
          <p className="text-xs font-medium text-slate-500">Email address</p>
          <p className="text-sm text-slate-900">
            {config?.config.support.email}
          </p>
        </div>
      </div>
      <h3>Your account manager</h3>
      <div className="flex flex-col space-y-4 p-3 mt-4 mb-8 border border-slate-200 shadow-md rounded-md">
        <h2 className="text-slate-700 text-sm">Admin User</h2>
        <div className="flex flex-col space-y-1">
          <p className="text-xs font-medium text-slate-500">Phone</p>
          <p className="text-sm text-slate-900">
            {config?.config.support.phone}
          </p>
        </div>
        <hr />
        <div className="flex flex-col space-y-1">
          <p className="text-xs font-medium text-slate-500">Email address</p>
          <p className="text-sm text-slate-900">
            {config?.config.support.email}
          </p>
        </div>
      </div>
      <h3>Departments contact information</h3>
      <div className="flex flex-col space-y-4 p-3 mt-4 mb-8 border border-slate-200 shadow-md rounded-md">
        <div className="flex justify-between items-center">
          <div className="flex flex-col space-y-2">
            <p className="text-xs font-medium text-slate-500">Support Team</p>
            <p className="text-sm text-slate-500">
              You couldn't find a hotel or a room category online? We'll help
              you!
            </p>
          </div>
          <button
            onClick={toggleAccordion}
            className={`transform transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
          >
            <ChevronDown color="gray" />
          </button>
        </div>
        <div
          className={` border-slate-200 rounded-md transition-height duration-300 ${isOpen ? "border max-h-40" : "max-h-0 overflow-hidden"}`}
        >
          <div className="flex flex-col p-3">
            <p className="text-xs text-slate-500">Phone</p>
            <p className="text-sm text-slate-900">
              {config?.config.support.phone}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportDetailCard;
